import {
  FeedbackQuery,
  FeedbackTimelineQueryType,
} from "@reflag/shared/feedbackAPI";
import { NotificationProvider } from "@reflag/shared/notification";

const qk = {
  list: (
    appId?: string,
    envId?: string,
    params?: Omit<FeedbackQuery, "envId">,
  ) =>
    [
      "apps",
      appId,
      "environment",
      envId,
      "feedbacks",
      ...(params ? [params] : []),
    ] as const,

  single: (appId?: string, envId?: string, feedbackId?: string) => [
    ...qk.list(appId, envId),
    feedbackId,
  ],

  timeline: (
    appId: string | undefined,
    envId: string | undefined,
    params: Omit<FeedbackTimelineQueryType, "envId">,
  ) =>
    [
      ...qk.list(appId, envId),
      "timeline",
      ...(params ? [params] : []),
    ] as const,

  push: (
    appId?: string,
    envId?: string,
    provider?: NotificationProvider,
    feedbackId?: string,
  ) => [...qk.single(appId, envId, feedbackId), "push", provider],
};

export { qk as feedbackQueryKeys };
